export const MuiCard = (mode) => {
  return {
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          borderRadius: theme.shape.borderRadius * 2,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: theme.palette.mode === "dark" ? "none" : theme.shadows[1],
          overflow: "hidden",
        }),
      },
      variants: [
        {
          props: { variant: "outlined" },
          style: {
            boxShadow: "none",
          },
        },
      ],
    },
  };
};
